module.exports = __webpack_public_path__ + "img/ic_team_tiktok.9570b2bf.svg";